<template>
  <transition name="zk-notification-fade">
    <div class="zk-notification" v-show="visible" :style="{ top: top ? top + 'px' : 'auto' }" @mouseenter="clearTimer()" @mouseleave="startTimer()">
      <i class="zk-notification__icon" :class="[ typeClass ]" v-if="type"></i>
      <div class="zk-notification__group" :style="{ 'margin-left': typeClass ? '55px' : '0' }">
        <span>{{ title }}</span>
        <p>{{ message }}</p>
        <div class="zk-notification__closeBtn zk-icon-close" @click="handleClose()"></div>
      </div>
    </div>
  </transition>
</template>

<script type="text/babel">
  let typeMap = {
    success: 'circle-check',
    info: 'information',
    warning: 'warning',
    error: 'circle-cross'
  };

  export default {
    data() {
      return {
        visible: false,
        title: '',
        message: '',
        duration: 4500,
        type: '',
        onClose: null,
        closed: false,
        top: null,
        timer: null
      };
    },

    computed: {
      typeClass() {
        return this.type && typeMap[this.type] ? `zk-icon-${ typeMap[this.type] }` : '';
      }
    },

    watch: {
      closed(newVal) {
        if (newVal) {
          this.visible = false;
          this.$el.addEventListener('transitionend', this.destroyElement);
        }
      }
    },

    methods: {
      destroyELement() {
        this.$el.removeEventListener('transitionend', this.destroyELement);
        this.$destroy(true);
        this.$el.parentNode.removeChild(this.$el);
      },

      handleClose() {
        this.closed = true;
        if (typeof this.onClose === 'function') {
          this.onClose();
        }
      },

      clearTimer() {
        clearTimeout(this.timer);
      },

      startTimer() {
        if (this.duration > 0) {
          this.timer = setTimeout(() => {
            if (!this.closed) {
              this.handleClose();
            }
          }, this.duration);
        }
      }
    },

    mounted() {
      if (this.duration > 0) {
        this.timer = setTimeout(() => {
          if (!this.closed) {
            this.handleClose();
          }
        }, this.duration);
      }
    }
  };
</script>



// WEBPACK FOOTER //
// notification.vue?3f39f33f